import { render, staticRenderFns } from "./content-list-view.vue?vue&type=template&id=41e20a8a&"
import script from "./content-list-view.vue?vue&type=script&lang=js&"
export * from "./content-list-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports